import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Channels from "@/pages/Channels";
import ChannelDetail from "@/pages/ChannelDetail";
import Servers from "@/pages/Servers";
import ServerDetail from "@/pages/ServerDetail";
import Lab from "@/pages/Lab";
import Providers from "@/pages/Providers";
import AccessLog from "@/pages/AccessLog";
import Incidents from "@/pages/Incidents";
import Node from "@/pages/Node";
import SettingsPage from "@/pages/Settings";
import Acceptance from "@/pages/Acceptance";
import Alerts from "@/pages/Alerts";
import Reliability from "@/pages/Reliability";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500 font-mono text-sm">checking session…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/channels" replace />} />
            <Route path="/channels" element={<Channels />} />
            <Route path="/channels/:id" element={<ChannelDetail />} />
            <Route path="/servers" element={<Servers />} />
            <Route path="/servers/:id" element={<ServerDetail />} />
            <Route path="/lab" element={<Lab />} />
            <Route path="/providers" element={<Providers />} />
            <Route path="/access-log" element={<AccessLog />} />
            <Route path="/incidents" element={<Incidents />} />
            <Route path="/node" element={<Node />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/acceptance" element={<Acceptance />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/reliability" element={<Reliability />} />
          </Route>
          <Route path="*" element={<Navigate to="/channels" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}
